import React, { useRef } from 'react'
import styled from 'react-emotion'
import {
  border,
  borderRadius,
  rowHeight,
  z,
  sidebarWidth
} from '../../style'
import ActivityItem from './ActivityItem'
import ActivityToolbar from './ActivityToolbar'
import Loader from '../common/Loader'
import { isLoaded } from 'react-redux-firebase'
import useClickOutside from '../../hooks/useClickOutside'
import { ScrollArea } from 'common/components';

const inset = 5

const Activity = styled(
  ({ activity, sidebarShowing, toggleActivity, className }) => {
    const ref = useRef()
    useClickOutside(ref, !sidebarShowing && toggleActivity)
    return (
      <>
        <div className={className} ref={ref}>
          <ActivityToolbar />
          {!isLoaded(activity) ? (
            <Loader />
          ) : (
            <ScrollArea>
              {(activity || []).map(
                item =>
                  item.type && (
                    <ActivityItem activityItem={item} key={item.id} />
                  )
              )}
            </ScrollArea>
          )}
        </div>
      </>
    )
  }
)({
  label: 'Activity',
  position: 'absolute',
  top: rowHeight.default + inset,
  left: inset,
  width: sidebarWidth - inset * 2,
  bottom: inset,
  display: 'flex',
  flexDirection: 'column',
  border,
  borderRadius,
  background: 'white',
  zIndex: z.activity
})

export default Activity
